<template>
    <div>
        <div class="row m-0">
            <div v-if="header.length != 0" class="col-md-4 col-sm-3 col-5 mt-3 p-2 font-weight-bold titleBlock" v-html="header">
            </div>
            <div v-if="header2.length != 0" class="col-md-3 col-sm-3 col-3 mt-3 p-2 pl-3 font-weight-bold titleBlock-part2">
                {{header2}}
            </div>
            <div v-if="header3.length != 0" class="col-md-5 col-sm-6 col-4 mt-3 p-2 titleBlock-part3 text-right">
                {{header3}}
            </div>
        </div>
        <!-- BOOK DISPLAY  -->
        <div class="bookD">
            <div class="row">
                <ul class="list-unstyled" ref="scroller" style="padding:0px 10px">
                    <li v-for="(book,index) in books" :key="index" class="col-lg-4 col-md-6 col-sm-6">
                        <div class="imgTop mb-2">
                            <img v-bind:src="book.image" :alt="book.header | decoder" :title="book.header | decoder">
                        </div>
                        <b v-html="$options.filters.decoder(book.header)"></b>
                        <p v-html="$options.filters.decoder(book.text)"></p>
                        <div class="row bookPriceRow">
                            <div class="col-md-8 col-sm-12">
                                <a class="pl-2" :href="book.url" :target="book.url_target" v-if="book.linktekst">{{ book.linktekst }}</a>
                                <a class="pl-2" :href="book.url" :target="book.url_target" v-else="linktekst">Lees meer</a>
                            </div>
                            <div class="col-md-4 col-sm-12 price pr-2 text-right" v-html="book.price" v-if="book.price"></div>
                        </div>
                    </li> 
                </ul>
            </div>
            
        </div>
        <div class="row justify-content-end" v-if="base">
            <div class="col-md-4 col-sm-5 p-2 mb-3 titleBlockBottom">
                <a :href="base.url" class="no-underline text-white">{{base.text}}</a>
            </div>
        </div> 
    </div>
</template>

<script> 
    export default { 
        name:"book-display", 
        components:{ 
        },
        props:{
            header:{type:String,required:true},
            header2:{type:String,required:true},
            header3:{type:String,required:true},
            books:{type:Array,required:true},
            base:{type:Object},
        },

        data(){
            return {
                 
            }
        },

        filters:{
            decoder : function(value){
                if (!value) return ''
                return window.atob(value);
            }
        }
    }
</script>

<style scoped>
    .imgTop{
        height: 140px;
    } 
    .bookD{
        border-top:2px solid gray;
    } 
    .bookD ul{
        display: block;
        padding-left: 10px;
        overflow-x: hidden;
        overflow-y: hidden; 
    }
    .bookD ul li{
        text-align: center;
        border-right:1px solid black;
        margin: 15px 0px;
        padding-top: 0px;
        display: inline-block;
    }
    .bookD ul li:nth-child(3n){
        border: none !important;
    }
    .bookD ul li:last-child{
        border: none !important;
    }
    .bookD ul li img{
        width: auto;
        height: 140px;
        padding: 10px;
    }
    .bookD ul li b{
        display: block;
        text-align: left;
        padding:0px 13px;
        height: 75px;
    }
    .bookD ul li p{
        text-align: left;
        padding:0px 13px;
        font-size:13px;
        height: 145px;
    }
    .bookD ul li a{
        text-decoration: none;
        color:black;
        text-align: left;
        display: block;
        font-weight: bold;
        font-size:large;
    }

    .price{
        font-weight: 700;
        font-size: 1.1rem;
    }
    
    @media (max-width:576px){
          .bookD ul li{
              border:none;
              margin: 10px auto;
              display: block;
              border-bottom: 1px solid gray !important;
          }  
        .bookD ul li:nth-child(3){
            border-bottom: 1px solid gray !important;
        }
    }

    @media (max-width:768px){
        .price{
            text-align: left !important;
            margin-left: .5rem!important;
        }
    }

    @media (max-width:1200px){
      .bookPriceRow a,
      .bookPriceRow .price{
        font-size: 0.9rem !important;
      }
    }
</style>




// WEBPACK FOOTER //
// src/components/overall_layouts/book-display.vue